import { ButtonTheme, ButtonWidgetBaseData, IBackgroundStyle, IBorderRadiusData, IButtonBaseStyle, IFontData, IPagePrimaryElement, WidgetPlaceType } from "@pageBuilder/typings";
import { IAnimatedWidget } from "../widget-style-data";

export interface ICalendarEventDetailsWidgetData extends IPagePrimaryElement {
    type: "CalendarEventDetailsWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    eventModelBase64?: string | null;
    style: ICalendarEventDetailsWidgetStyle;
}

export interface ICalendarEventDetailsWidgetShortData {
    style: ICalendarEventDetailsWidgetShortStyle;
}

export interface ICalendarEventDetailsWidgetStyle extends IAnimatedWidget {
    font: IFontData;
    headingFont: IFontData;
    textFont: IFontData;
    button: IButtonBaseStyle;
    padding: number;
    background: IBackgroundStyle;
    borderThickness: number;
    borderColor: string;
    borderRadius: IBorderRadiusData;
}

export interface ICalendarEventDetailsWidgetShortStyle {
    buttonTheme?: ButtonTheme | null;
}

export abstract class CalendarEventDetailsWidgetData {

    public static get defaultData(): ICalendarEventDetailsWidgetData {
        return {
            type: "CalendarEventDetailsWidget",
            placeType: "Section",
            primaryElement: true,
            style: this.defaultStyle
        };
    }

    public static get defaultStyle(): ICalendarEventDetailsWidgetStyle {
        return {
            font: {
                family: "Open Sans",
            },
            headingFont: {},
            textFont: {},
            padding: 16,
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            },
            borderRadius: {
                topLeftPx: 0,
                topRightPx: 0,
                bottomLeftPx: 0,
                bottomRightPx: 0
            },
            background: {
                color: "#ffffff"
            },
            borderThickness: 0,
            borderColor: "#D2D2D5",
            button: ButtonWidgetBaseData.defaultButtonStyle,
        };
    }

    public static isLocalScriptRerenderNeeded(leftHandSide?: ICalendarEventDetailsWidgetData | null, rightHandSide?: ICalendarEventDetailsWidgetData | null): boolean {
        if (!leftHandSide || !rightHandSide) {
            return true;
        }

        if (leftHandSide.style.button?.theme !== rightHandSide.style.button?.theme) {
            return true;
        }

        return leftHandSide.id !== rightHandSide.id;
    }

}
